import Login from "./login/Login";
import React from "react";
import Tabs from "../../../components/custom/Tabs";
// import LanguagesDropdown from "../../../components/custom/LanguagesDropdown.js/index.js";
import styled from "styled-components/macro";
import CreateAccount from "./login/CreateAccount/index";
// import { Box } from "@mui/system";
import { useTranslation } from "react-i18next";

const StyledTabDiv = styled.div`
  ${(props) => props.theme.breakpoints.down("sm")} {
    padding-top: 0px;
    padding-right: 0px;
    padding: 10px;
    display: flex;
    justify-content: center;
    flex-direction: column;
  }
  padding-top: 90px;
  padding-right: 50px;
  width: 100%;
  overflow: scroll;
`;

// const LanguageBox = styled(Box)`
//   display: flex;
//   justify-content: center;
// `;

const AccountLanding = () => {
  const { t } = useTranslation();
  return (
    <>
      <StyledTabDiv>
        <Tabs labels={[{ text: t("Login") }, { text: t("Create Account") }]}>
          <Login />
          <CreateAccount />
        </Tabs>
      </StyledTabDiv>
    </>
  );
};

export default AccountLanding;
